<template>
	<div>
		<v-card
			width="500px"
			outlined
			flat
			class="mt-2"
		>
			<v-card-text
				class="analysis_mess"
			>
				キーワードの印象値は以下の要素で変化します。
				<ul>
					<li>ワードのユニークさ(変更不可)</li>
					<li>ワード数</li>
					<li>出現数</li>
					<li>出現箇所(タイトルやサブタイトル、出現する行数)</li>
					<li>強調</li>
				</ul>
			</v-card-text>
		</v-card>
		<v-card
			width="500px"
			max-height="calc(100vh - 400px)"
			class="overflow-y-auto"
		>
			<v-list>
				<v-list-item
					v-for="item in analysis_key"
					v-bind:key="item.key"
				>
					<v-card
						width="100%"
					>
						<v-card-text
							@click="check"
							:id="'pre-'+item.key"
						>
								<v-row>
								<v-col 
									cols="10"
									:id="item.key"
								>
									<span class="analysis_key" :id="item.key">{{ item.key }}</span>
								</v-col>
								<v-col
									:id="item.key"
								>
									<span class="analysis_key" :id="item.key">{{ item.tfidf }}</span>
								</v-col>
								</v-row>
						</v-card-text>
					</v-card>
				</v-list-item>
			</v-list>
		</v-card>
	</div>
</template>
<script>
module.exports={
	props : ["analysis_key",],
	watch : {
		analysis_key : function(){
			console.log(this.analysis_key);
		},
	},
	data : function(){
		return {
			selected_word : "",
		}
	},
	methods : {
        check    : function(event){
            const elem = document.getElementById('pre-'+event.target.id);
            if(event.target.id.indexOf('pre-') >= 0)
                return;

            if(this.selected_word != "")
            {
                const before_elem = document.getElementById('pre-'+this.selected_word);
                if(before_elem != undefined)
                    before_elem.style.backgroundColor="";
            }
            this.selected_word = event.target.id;
            elem.style.backgroundColor="#FDF0F0";
			this.$emit("word",{"word":this.selected_word});
        },
	},
}
</script>
